import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { tokenStorage } from '@/api/client';

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { public: true, title: 'Вход' },
  },
  {
    path: '/',
    component: () => import('@/layout/MainLayout.vue'),
    children: [
      { path: '', redirect: '/applications' },
      {
        path: 'applications',
        name: 'applications',
        component: () => import('@/views/ApplicationsView.vue'),
        meta: { title: 'Приложения' },
      },
      {
        path: 'users',
        name: 'users',
        component: () => import('@/views/UsersView.vue'),
        meta: { title: 'Учётные записи' },
      },
      {
        path: 'user-groups',
        name: 'user-groups',
        component: () => import('@/views/UserGroupsView.vue'),
        meta: { title: 'Группы пользователей' },
      },
      {
        path: 'roles',
        name: 'roles',
        component: () => import('@/views/RolesView.vue'),
        meta: { title: 'Роли' },
      },
      {
        path: 'permissions',
        name: 'permissions',
        component: () => import('@/views/PermissionsView.vue'),
        meta: { title: 'Разрешения' },
      },
      {
        path: 'groups',
        name: 'groups',
        component: () => import('@/views/GroupsView.vue'),
        meta: { title: 'Группы политик' },
      },
    ],
  },
  { path: '/:pathMatch(.*)*', redirect: '/' },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to) => {
  const isPublic = to.matched.some((r) => r.meta.public);
  const hasSession = Boolean(tokenStorage.refresh);
  if (!isPublic && !hasSession) {
    return { name: 'login', query: { next: to.fullPath } };
  }
  if (to.name === 'login' && hasSession) {
    return { path: '/' };
  }

  const title = (to.meta.title as string) || 'Админка';
  document.title = `${title} — Botto Auth`;
  return true;
});
